import { useEffect } from 'react'
import ReactGA from 'react-ga'
import ReactGA4 from 'react-ga4'
import { useLocation } from 'react-router-dom'
// import { LiveChatWidget } from '@livechat/widget-react'

import { ROUTES } from '../utils/constants/enum'
import Content from './Content'
import Footer from './Footer'
import Header from './Header'

ReactGA.initialize(`${process.env.REACT_APP_GA_ID}`)
ReactGA4.initialize(`${process.env.REACT_APP_GA4_ID}`)

const ACCOUNTS_ROUTES = [
    ROUTES.SIGNIN,
    ROUTES.SIGNUP,
    ROUTES.DASHBOARD,
    ROUTES.ACCOUNT_SETTINGS,
    ROUTES.TREATMENT_HISTORY,
    ROUTES.TREATMENT,
    ROUTES.PROVIDER,
    ROUTES.STORE_TAB,
    ROUTES.SYNDEO_REPORTS,
    ROUTES.HYDRAFACIALISTS,
    ROUTES.THE_DROP,
    ROUTES.SIGNUPSTEPS,
    ROUTES.SIGNIN,
    ROUTES.ACCOUNT_DELETE,
    ROUTES.REWARDS_PAGE,
    ROUTES.DOWNLOAD_APP,
    ROUTES.SELECTACCOUNT,
    ROUTES.CONSENT,
    `${ROUTES.SIGNIN}`,
    `${ROUTES.SIGNUP}`,
    `${ROUTES.ACCOUNTS}`,
]

const Layout = () => {
    const location = useLocation()

    const isAccountsRoute = ACCOUNTS_ROUTES?.some(
        (path: string) =>
            location.pathname === path || location.pathname.startsWith(path)
    )

    useEffect(() => {
        const page = location.pathname + location.search
        ReactGA.pageview(page)
        ReactGA4.send(page)
    }, [location])

    return (
        <>
            {isAccountsRoute ? null : (
                <>
                    <Header />
                    {/* <LiveChatWidget
                        license={`${process.env.REACT_APP_LIVECHAT_LICENSE}`}
                        visibility="maximized"
                    /> */}
                </>
            )}
            <div className="container">
                <Content />
            </div>
            {isAccountsRoute ? null : <Footer />}
        </>
    )
}

export default Layout
